import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { LongTextField, useFieldLabel } from "ra-friendsofbabba";
import React from "react";
import { get } from "lodash";

const ActivitiesTableField = ({ record }) => {
  const activities = get(record, "activities", []);
  const fieldLabel = useFieldLabel({
    resource: "executive-project-work-package-activities",
  });
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell colSpan={2}>{fieldLabel("name")}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{fieldLabel("id")}</TableCell>
          <TableCell>{fieldLabel("description")}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {activities
          .filter((a) => a.type === "original")
          .map((activity, index) => (
            <TableRow key={activity.id}>
              <TableCell>
                {get(record, "order_index")}.{index + 1}
              </TableCell>
              <TableCell>
                <LongTextField
                  record={activity}
                  source="description"
                  variant="body2"
                  maxRows={3}
                />
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
};
export default ActivitiesTableField;
